import { Tooltip as TooltipPrimitive } from "radix-ui";
import type { ReactElement, ReactNode } from "react";

import { appConfig } from "@/config/app";

import styles from "./Tooltip.module.css";

/** One provider at the app root so moving between tooltips skips the delay. */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipPrimitive.Provider delayDuration={appConfig.tooltipDelayMs}>
      {children}
    </TooltipPrimitive.Provider>
  );
}

export interface TooltipProps {
  content: ReactNode;
  /** A single focusable element; it becomes the trigger. */
  children: ReactElement;
  side?: "top" | "right" | "bottom" | "left";
}

/** Hover and focus hint. Never the only place information lives: tooltips don't show on touch. */
export function Tooltip({ content, children, side = "top" }: TooltipProps) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={appConfig.overlayOffsetPx}
          className={`${styles.tooltip} animate-in`}
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
